import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/message/base"

const message = {
  messageList(pageSize, limit, title) {
    return axios.get(pre + `/messageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          title: title,
        }
    });
  },
  getMessageInfo(id) {
    return axios.get(pre + `/getMessageInfo`, {params: {id: id}});
  },
  saveMessage(params) {
    return axios.post(pre + `/saveMessage`, qs.stringify(params));
  },
  deleteMessage(id) {
    return axios.post(pre + `/deleteMessage`, qs.stringify({id: id}));
  },
}
export default message;



// WEBPACK FOOTER //
// ./src/api/message/message.js